// store/index.js
// Vue 2 中导入 Vuex 的方式（不是解构createStore）
import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

// Vue 2 必须先注册 Vuex
Vue.use(Vuex)

// auth模块逻辑不变，仅调整Store创建方式
const authModule = {
  namespaced: true,
  state: { // Vuex 3 中state可以直接是对象（也可以是函数，推荐函数避免引用共享）
    CLIENT_CONFIG: {
      client_cd: '',
      client_nm: '',
      client_dev: '',
      client_dev_nm: '',
      client_os: '',
      client_info: '',
      client_gate: '',
      client_enc: '',
      client_agent: '',
      client_type: 0,
      client_hsp: ''
    },
    TOKEN_CONFIG: {
      token: '',
      expires: new Date(),
      usr_cd: 0,
      usr_nm: '',
      usr_role: [],
      usr_pwd: '',
      grp_cd: 0,
      hsp_cd: 0,
      role_cd: 0,
      usr_tag: {},
      usr_gid: '',
      run_id: ''
    },
    router: 'login',
    isLoginPages: true,
    CALL_OUT_MSG:{},
    // IS_MASK_NAME:true, //是否启用姓名脱敏

    // IS_OPEN_VIDEO:false,
    // VIDEO_SWI_TIME:10, //默认十分钟切换
    // LOOP_PLAY:false
  },
  mutations: {
    SET_CLIENT_CONFIG(state, obj) {
      state.CLIENT_CONFIG = obj
    },
    SET_CALL_OUT_MSG(state, obj) {
      state.CALL_OUT_MSG = obj
    },
    SET_CLIENT_GATE(state, obj) {
      state.CLIENT_CONFIG.client_gate = obj
    },
    SET_TOKEN_CONFIG(state, obj) {
      state.TOKEN_CONFIG = obj
    },
    SET_TOKEN_EXPIRES(state) {
      state.TOKEN_CONFIG.token = ''
      state.TOKEN_CONFIG.expires = new Date()
      state.TOKEN_CONFIG.usr_cd = 0
      state.TOKEN_CONFIG.usr_nm = ''
      state.TOKEN_CONFIG.usr_role = []
      state.TOKEN_CONFIG.usr_tag = {}
      state.TOKEN_CONFIG.hsp_cd = 0
      state.TOKEN_CONFIG.grp_cd = 0
      state.TOKEN_CONFIG.run_id = ''
    },
    SET_ROUTER(state, value) {
      state.router = value
    },
    SET_IS_LOGIN_PAGES(state, value) {
      state.isLoginPages = value
    },
    // SET_IS_MASK_NAME(state, value) {
    //   state.IS_MASK_NAME = value
    // }

  }
}

// Vue 2 中创建Store的正确方式：new Vuex.Store()
const store = new Vuex.Store({
  modules: {
    auth: authModule
  },
  plugins: [
    createPersistedState({
      key: 'tengshun-dev',
      storage: window.localStorage, // Vue 2 中显式指定window更稳妥
      paths: ['auth']
    })
  ]
})

export default store